<template>
  <div class="header">
    <div index="0" class="logo">
      <div class="logo-text">
        <div class="logo-text__zh">琮联电子</div>
        <div class="logo-text__en">CONGLIAN ELECTRONICS</div>
      </div>
    </div>
    <el-menu mode="horizontal">

      <el-menu-item @click="to('')" index="1">首页</el-menu-item>
      <el-menu-item @click="to('harness')" index="2">线束加工</el-menu-item>
      <el-menu-item @click="to('pcba')" index="3">PCBA</el-menu-item>
      <el-menu-item @click="to('about')" index="4">关于我们</el-menu-item>
    </el-menu>
<!--    <el-input></el-input>-->
<!--    <div class="logo" @click="to('')">-->
<!--      <img :src="logo" />-->
<!--    </div>-->
<!--    <div class="nav_tab">-->
<!--      <div @click="to('')">首页</div>-->
<!--      <div @click="to('production')">生产中心</div>-->
<!--      <div @click="to('product')">产品中心</div>-->
<!--    </div>-->
<!--    <div class="about_us" @click="to('about')">关于甬惠</div>-->
  </div>
</template>

<script>
export default {
  name: "CommonHeader",
  methods: {
    to(path) {
      this.$router.push("/" + path);
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  border-bottom: solid 1px #e6e6e6;
  box-shadow: 0 4px 18px 0 rgba(151,151,151,0.5);
  display: flex;
  height: 80px;
  .logo {
    width: 20%;
    display: flex;
    align-items: center;
    .logo-text {
      color: #22346F;
      margin-left: 50px;
      .logo-text__zh {
        font-weight: 300;
        height: 50px;
        line-height: 60px;
        font-size: 20px;
      }
      .logo-text__en {
        font-weight: 900;
        line-height: 12px;
        height: 30px;
        font-size: 10px;
      }
    }
  }

  /deep/ .el-menu {
    width: 80%;
    display: flex;
    justify-content: space-between;
    font-size: 25px;
    height: 100%;
  }
  /deep/ .el-menu-item, /deep/ .el-submenu__title{
    //margin: 0 80px;
    // 字体
    color: #222220 !important;
    font-weight: 600;
    line-height: 18px;
    font-size: 18px;
    // 上下居中
    display: flex;
    align-items: center;
    height: 100% !important;
  }

}

::v-deep .el-menu-item.ssbb {
  color: #13ce66 !important;
}
</style>
